/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-not-allowed-site',
  templateUrl: './dialog-not-allowed-site.component.html',
  styleUrls: ['./dialog-not-allowed-site.component.scss']
})
export class DialogNotAllowedSiteComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(public dialogRef: MatDialogRef<DialogNotAllowedSiteComponent>, @Inject(MAT_DIALOG_DATA) public message: string) {
  }

  ngOnInit(): void {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                    LISTENERS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public close(): void {
    this.dialogRef.close();
  }
}
